<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">رقم ترخيص الإعلان:</label>
          <div>{{ dataRow.adLicenseNumber }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">كود حالة الترخيص:</label>
          <div>{{ dataRow.adlicenseStatusCode }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">حالة الترخيص:</label>
          <div>{{ dataRow.adlicenseStatusNameAR }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">تاريخ الإجراء:</label>
          <div class="date-format">{{ formatDate(dataRow.actionDateTime) }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-3">
          <label class="form-label">سبب الإجراء:</label>
          <div>{{ dataRow.actionReason }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-3">
          <label class="form-label">بيانات الطلب:</label>
          <div class="english-input"><pre>{{ dataRow.requestBody ? JSON.stringify(dataRow.requestBody, null, 2) : '' }}</pre></div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { formatDate } from '@/helpers/tools';

export default {
  name: 'RegaForm',
  props: {
    cardTitle: {
      type: String,
      default: 'تفاصيل التنبيه'
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
    }
  },
  methods: {
    formatDate,
  },
}
</script>